"use client";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { faker } from '@faker-js/faker';
import { generateDataBackgroundChartWeek, generateDataColorChartWeek } from "../../utils/common";

interface LineProps {
  dataset: number[];
}
// Register ChartJS components using ChartJS.register
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

export function createGradient (context: any, color1: string, color2: string) {
  const chart = context.chart;
  const {ctx, chartArea} = chart;
  if (!chartArea) {
    return null;
  }
  const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
  gradient.addColorStop(0, color1);  // Más claro
  gradient.addColorStop(1, color2);    // Más oscuro
  return gradient;
}

export const ChartBarEmotions: React.FC<LineProps> = ({ dataset }) => {
  const RoundedBar = {
    id: 'roundedBar',
    beforeDatasetsDraw(chart: any) {
      const { ctx, data, chartArea: { top, bottom }, } = chart;
      const colors = generateDataBackgroundChartWeek(dataset);

      ctx.save();
      data.datasets.forEach((_: any, i: number) => {
        chart.getDatasetMeta(i).data.forEach((bar: {x: number;  width: number}, idx: number) => {
          const { x: barX, width: barWidth } = bar;

          ctx.fillStyle = colors[idx];
          
          const radius = 10;
          const height = bottom - top;
          const x = barX - barWidth / 2;
          const y = top;

          ctx.beginPath();
          ctx.moveTo(x + radius, y);
          ctx.lineTo(x + barWidth - radius, y);
          ctx.quadraticCurveTo(x + barWidth, y, x + barWidth, y + radius);
          ctx.lineTo(x + barWidth, y + height - radius);
          ctx.quadraticCurveTo(x + barWidth, y + height, x + barWidth - radius, y + height);
          ctx.lineTo(x + radius, y + height);
          ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
          ctx.lineTo(x, y + radius);
          ctx.quadraticCurveTo(x, y, x + radius, y);
          ctx.closePath();

          ctx.fill();

        });
      });
      ctx.restore();
    }
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        display: false,
      },
      y: {
        display: false,
        suggestedMax: 6
      },
    },
    elements: {
      bar: {
          borderRadius: 10,
          borderSkipped: false,
      }
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  const labels = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'];

  const values: any = {
    labels,
    datasets: [
      {
        label: 'Dataset 1',
        data: dataset,
        backgroundColor: function(context: any) {
          return generateDataColorChartWeek(context, dataset)
        },
      },
    ],
  };
  return (
    <Bar options={options} data={values} plugins={[RoundedBar]}/>
  );
};